function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M56.879 45.6323V32.9806C59.0642 32.6658 60.75 30.7865 60.75 28.5161C60.75 26.0265 58.7242 24 56.2339 24C53.7435 24 51.7177 26.0265 51.7177 28.5161H20.75V54.3226H40.1377C40.4732 59.7135 44.9539 64 50.4274 64C56.119 64 60.75 59.369 60.75 53.6774C60.75 50.4265 59.2358 47.5258 56.879 45.6323ZM56.2339 25.2903C58.0126 25.2903 59.4597 26.7374 59.4597 28.5161C59.4597 30.2948 58.0126 31.7419 56.2339 31.7419C54.4552 31.7419 53.0081 30.2948 53.0081 28.5161C53.0081 26.7374 54.4552 25.2903 56.2339 25.2903ZM22.0403 29.8065H51.9081C52.0623 30.3213 52.3074 30.7955 52.6223 31.2161L48.6765 35.1619C48.4235 35.0406 48.1448 34.9677 47.8468 34.9677C47.5487 34.9677 47.27 35.0406 47.0177 35.1619L45.7177 33.8619C45.8384 33.609 45.9113 33.3303 45.9113 33.0323C45.9113 31.9652 45.0429 31.0968 43.9758 31.0968C42.9087 31.0968 42.0403 31.9652 42.0403 33.0323C42.0403 33.3303 42.1132 33.609 42.2345 33.8613L38.999 37.0968C38.7461 36.9761 38.4674 36.9032 38.1694 36.9032C37.1023 36.9032 36.2339 37.7716 36.2339 38.8387C36.2339 39.9058 37.1023 40.7742 38.1694 40.7742C39.2365 40.7742 40.1048 39.9058 40.1048 38.8387C40.1048 38.5406 40.0319 38.2619 39.9106 38.0097L43.1461 34.7742C43.399 34.8948 43.6777 34.9677 43.9758 34.9677C44.2739 34.9677 44.5526 34.8948 44.8048 34.7735L46.1048 36.0735C45.9842 36.3265 45.9113 36.6052 45.9113 36.9032C45.9113 37.9703 46.7797 38.8387 47.8468 38.8387C48.9139 38.8387 49.7823 37.9703 49.7823 36.9032C49.7823 36.6052 49.7094 36.3265 49.5881 36.0742L53.5345 32.1284C54.1248 32.571 54.8255 32.871 55.5887 32.9813V44.7523C54.0681 43.869 52.3087 43.3548 50.4274 43.3548C47.3435 43.3548 44.5784 44.7213 42.6855 46.8729V44H38.8145V51.7419H40.2932C40.2132 52.1632 40.1648 52.5948 40.1377 53.0323H22.0403V29.8065ZM47.8468 36.2581C48.2023 36.2581 48.4919 36.5471 48.4919 36.9032C48.4919 37.2594 48.2023 37.5484 47.8468 37.5484C47.4913 37.5484 47.2016 37.2594 47.2016 36.9032C47.2016 36.5471 47.4913 36.2581 47.8468 36.2581ZM43.3306 33.0323C43.3306 32.6761 43.6203 32.3871 43.9758 32.3871C44.3313 32.3871 44.621 32.6761 44.621 33.0323C44.621 33.3884 44.3313 33.6774 43.9758 33.6774C43.6203 33.6774 43.3306 33.3884 43.3306 33.0323ZM38.8145 38.8387C38.8145 39.1948 38.5248 39.4839 38.1694 39.4839C37.8139 39.4839 37.5242 39.1948 37.5242 38.8387C37.5242 38.4826 37.8139 38.1935 38.1694 38.1935C38.5248 38.1935 38.8145 38.4826 38.8145 38.8387ZM50.4274 58.8387C47.5816 58.8387 45.2661 56.5232 45.2661 53.6774C45.2661 50.8316 47.5816 48.5161 50.4274 48.5161C53.2732 48.5161 55.5887 50.8316 55.5887 53.6774C55.5887 56.5232 53.2732 58.8387 50.4274 58.8387ZM41.3952 48.691C41.0861 49.2484 40.8306 49.8374 40.6281 50.4516H40.1048V45.2903H41.3952V48.691ZM49.7823 44.6781V47.2587C46.5268 47.5839 43.9758 50.3381 43.9758 53.6774C43.9758 54.6213 44.1848 55.5161 44.5506 56.3252L42.3126 57.6174C41.7306 56.4252 41.3952 55.091 41.3952 53.6774C41.3952 48.9148 45.1029 45.011 49.7823 44.6781ZM50.4274 62.7097C47.3216 62.7097 44.5771 61.1335 42.9513 58.7387L45.1984 57.4413C46.3713 59.0658 48.2752 60.129 50.4274 60.129C52.5797 60.129 54.4835 59.0658 55.6565 57.4413L57.9035 58.7387C56.2777 61.1335 53.5332 62.7097 50.4274 62.7097ZM58.5423 57.6174L56.3042 56.3252C56.67 55.5161 56.879 54.6213 56.879 53.6774C56.879 50.3381 54.3281 47.5832 51.0726 47.2587V44.6781C55.7519 45.011 59.4597 48.9148 59.4597 53.6774C59.4597 55.091 59.1242 56.4252 58.5423 57.6174Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M50.4274 49.8064C48.2925 49.8064 46.5564 51.5425 46.5564 53.6774C46.5564 55.8122 48.2925 57.5483 50.4274 57.5483C52.5622 57.5483 54.2983 55.8122 54.2983 53.6774C54.2983 51.5425 52.5622 49.8064 50.4274 49.8064ZM50.4274 56.258C49.0041 56.258 47.8467 55.1006 47.8467 53.6774C47.8467 52.2541 49.0041 51.0967 50.4274 51.0967C51.8506 51.0967 53.008 52.2541 53.008 53.6774C53.008 55.1006 51.8506 56.258 50.4274 56.258Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6209 31.0967H23.3306V32.387H24.6209V31.0967Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9436 31.0967H25.9114V32.387H34.9436V31.0967Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6209 33.6775H23.3306V34.9678H24.6209V33.6775Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9436 33.6775H25.9114V34.9678H34.9436V33.6775Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6209 36.2581H23.3306V37.5484H24.6209V36.2581Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9436 36.2581H25.9114V37.5484H34.9436V36.2581Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6209 38.8386H23.3306V40.1289H24.6209V38.8386Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9436 38.8386H25.9114V40.1289H34.9436V38.8386Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3306 51.7419H27.2015V45.2903H23.3306V51.7419ZM24.6209 46.5806H25.9112V50.4516H24.6209V46.5806Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4919 51.7419H32.3629V46.5806H28.4919V51.7419ZM29.7823 47.8709H31.0726V50.4515H29.7823V47.8709Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6533 51.742H37.5243V41.4194H33.6533V51.742ZM34.9436 42.7098H36.234V50.4517H34.9436V42.7098Z",
  fill: "black"
});

var SvgTrends = function SvgTrends(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9271L40.8156 15.9192L40.7979 15.9209L40.7917 15.9254L40.8058 15.9271Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9001 15.9324L80.75 18.4197V13.4275L41.0245 15.9058L40.9001 15.9324Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7836 15.9254L40.7873 15.9209L40.7766 15.9218L40.7749 15.9245L40.7836 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.758 15.9226H40.7527V15.9245H40.758V15.9226Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8506 15.9298L40.8958 15.9138L40.8408 15.9172L40.8203 15.9279L40.8506 15.9298Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7677 15.9199H40.7651V15.927H40.7677V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4789V29.831L40.75 15.9644L0.75 24.4789Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9645L40.9002 15.9325L40.8505 15.9299L40.75 15.9645Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9058L80.75 7.4499V2.09875L40.8958 15.9139L41.0244 15.9058Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9139L40.8503 15.9299L40.9 15.9324L41.0244 15.9058L40.8958 15.9139Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 31.6591L40.75 15.9644L10.5713 31.6591H17.8946Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8406 15.9173L80.75 -4.83813V-11.5032L40.8157 15.9192L40.8406 15.9173Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.927L40.75 15.9643L40.8202 15.9279L40.8059 15.927Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9279L40.8407 15.9172L40.816 15.9192L40.8062 15.9271L40.8202 15.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3685 31.6591L40.7501 15.9644L23.7344 31.6591H27.3685Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.798 15.9209L80.75 -20.9291V-25.6389H76.2224L40.7874 15.9209H40.798Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.9253L40.75 15.9643L40.7918 15.9253H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7918 15.9254L40.798 15.9209H40.7873L40.7837 15.9254H40.7918Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2054 31.6591L40.7499 15.9644L30.7866 31.6591H33.2054Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7766 15.9218L67.1586 -25.6389H60.7523L40.7695 15.9218H40.7766Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9246L40.75 15.9645L40.775 15.9246H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7747 15.9199H40.7712V15.927H40.7747V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6591L40.75 15.9644L35.7202 31.6591H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7631 15.9226L54.0835 -25.6389H48.9366L40.7578 15.9226H40.7631Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9246L40.75 15.9645L40.7632 15.9246H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6571 31.6591L40.75 15.9644L39.844 31.6591H41.6571Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7525 15.9246L40.7499 15.9237L40.7525 15.9226L43.1502 -25.6389H38.3506L40.7499 15.9645L40.7525 15.9246Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9236L40.7524 15.9244V15.9226L40.75 15.9236Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6591L40.75 15.9644L43.8386 31.6591H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 -25.6389H27.4172L40.7499 15.9645L32.5641 -25.6389Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6591L40.75 15.9644L48.2954 31.6591H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7496 -25.6389H14.3413L40.7501 15.9645L20.7496 -25.6389Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6591L40.75 15.9644L54.1307 31.6591H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.639H0.75V-20.9301L40.75 15.9643L5.27774 -25.639Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6591L40.75 15.9644L63.6055 31.6591H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5032V-4.83813L40.75 15.9644L0.75 -11.5032Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.831V24.4789L40.75 15.9644L80.75 29.831Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.0979V7.44992L40.75 15.9645L0.75 2.0979Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50.45,
    cy: 53.5,
    r: 11.5,
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrends, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trends.8f4f94e5.svg";
export { ForwardRef as ReactComponent };